import {axios as http} from "@/plugins/http"

export default class Api {
    static categoryKktu(query) {
        return http.post("/api/v1/post/mark-ad-auto/category-kktu", query).then((resp) => {
            return resp.data
        })
    }
}
